var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":_vm.name,"transition":_vm.transition,"scrollable":_vm.scrollable,"width":_vm.width,"height":_vm.height},on:{"before-open":_vm.beforeOpen,"before-close":_vm.beforeClose,"opened":_vm.onOpened,"closed":_vm.onClosed}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea1f2082","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CustomModal.vue
// module id = null
// module chunks = 